// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
  height: 100%;
}

.search-page {
  width: 100%;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  background: #f5f5f5;
  margin: 0;
}

.search-controls {
  display: flex;
  gap: 15px;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.button-groups {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

.tableScrollWrapper {
  flex: 1 1;
  margin: 0 15px;
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 0;
  max-height: calc(100vh - 200px);
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.control-group label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.control-group input,
.control-group select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-width: 120px;
}

.control-group input:focus,
.control-group select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.sensor-group {
  min-width: 200px;
}

.sensor-group.hidden {
  display: none;
}

.sensor-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 120px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  background: #f9f9f9;
}

.sensor-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  padding: 4px;
  border-radius: 3px;
  transition: background-color 0.2s;
}

.sensor-checkbox:hover {
  background-color: #e9ecef;
}

.sensor-checkbox input[type="checkbox"] {
  margin: 0;
  min-width: auto;
}

.sensor-checkbox span {
  flex: 1 1;
  color: #555;
}

.no-sensors {
  color: #999;
  font-style: italic;
  padding: 8px;
  text-align: center;
}

button {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

button:hover:not(:disabled) {
  background: #0056b3;
}

button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.search-container {
  flex: 1 1;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.loading, .no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #666;
}

.loading {
  color: #007bff;
}

.no-data {
  color: #999;
}

.table-container {
  width: 100%;
}

.table-container h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 1.3em;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table-container th,
.table-container td {
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.table-container th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  position: sticky;
  top: 0;
}

.table-container tr:hover {
  background: #f8f9fa;
}

.status-pass {
  color: #27ae60;
  font-weight: 600;
}

.status-fail {
  color: #e74c3c;
  font-weight: 600;
}

@media (max-width: 768px) {
  .search-page {
    padding: 10px;
  }
  
  .search-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .control-group {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  
  .control-group input {
    min-width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["html, body, #root {\r\n  height: 100%;\r\n}\r\n\r\n.search-page {\r\n  width: 100%;\r\n  min-height: 0;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  background: #f5f5f5;\r\n  margin: 0;\r\n}\r\n\r\n.search-controls {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n  background: white;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.button-groups {\r\n  margin-left: auto;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.tableScrollWrapper {\r\n  flex: 1;\r\n  margin: 0 15px;\r\n  overflow: auto;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  min-height: 0;\r\n  max-height: calc(100vh - 200px);\r\n}\r\n\r\n.control-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.control-group label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #555;\r\n}\r\n\r\n.control-group input,\r\n.control-group select {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  min-width: 120px;\r\n}\r\n\r\n.control-group input:focus,\r\n.control-group select:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\r\n}\r\n\r\n.sensor-group {\r\n  min-width: 200px;\r\n}\r\n\r\n.sensor-group.hidden {\r\n  display: none;\r\n}\r\n\r\n.sensor-checkboxes {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  max-height: 120px;\r\n  overflow-y: auto;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 8px;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.sensor-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  padding: 4px;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.sensor-checkbox:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.sensor-checkbox input[type=\"checkbox\"] {\r\n  margin: 0;\r\n  min-width: auto;\r\n}\r\n\r\n.sensor-checkbox span {\r\n  flex: 1;\r\n  color: #555;\r\n}\r\n\r\n.no-sensors {\r\n  color: #999;\r\n  font-style: italic;\r\n  padding: 8px;\r\n  text-align: center;\r\n}\r\n\r\nbutton {\r\n  padding: 8px 16px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\nbutton:hover:not(:disabled) {\r\n  background: #0056b3;\r\n}\r\n\r\nbutton:disabled {\r\n  background: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.search-container {\r\n  flex: 1;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  padding: 20px 0;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  min-height: 0;\r\n}\r\n\r\n.loading, .no-data {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 16px;\r\n  color: #666;\r\n}\r\n\r\n.loading {\r\n  color: #007bff;\r\n}\r\n\r\n.no-data {\r\n  color: #999;\r\n}\r\n\r\n.table-container {\r\n  width: 100%;\r\n}\r\n\r\n.table-container h3 {\r\n  margin: 0 0 15px 0;\r\n  color: #2c3e50;\r\n  font-size: 1.3em;\r\n}\r\n\r\n.table-container table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.table-container th,\r\n.table-container td {\r\n  padding: 8px 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.table-container th {\r\n  background: #f8f9fa;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.table-container tr:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.status-pass {\r\n  color: #27ae60;\r\n  font-weight: 600;\r\n}\r\n\r\n.status-fail {\r\n  color: #e74c3c;\r\n  font-weight: 600;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .search-page {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .search-controls {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .control-group {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .control-group input {\r\n    min-width: 150px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
